const B =
  "https://static.prod-images.emergentagent.com/jobs/f33a589d-6ae1-4fa8-937d-37a21884ea4e/images/";

export const IMAGES = {
  hero_facility: B + "7e4f496672f35a08e7352e265f818a04f05a416a4f023ee178cd419f017761e9.jpeg",
  mat_texture: B + "abbd6bd82ae624b7dffbd0f53501dbfc1255616857c11b936612c45b53b72fb8.jpeg",
  puzzle_edge: B + "1ad1b2631aabc04da0529ce0c9e257d74a4249b17f1339f5a531966d81930b9f.jpeg",
  rollout: B + "ea72bf8e4613fdbc4445999ff310d43c8ddc760abaf6d449e034ccc642801f03.jpeg",
  wall_pads: B + "0f1160e49c52fafc17b5eb232fb3f7ae49fd5e956224e24a9fbc46d8bec23780.jpeg",
  bjj: B + "1f9c0a53dd1bbd32db46483867bc467b3dffa37320e97d81deaf2aabf83a27c5.jpeg",
  wrestling: B + "09bae644068f0f450ded9b15adc1a7ac6babc1e29185179cacb1203d6c85de5e.jpeg",
  tatami_stack: B + "8507fba5b2f0560439aeb841e2ad8f270722ebd87d76b5fc32f30fa289868055.jpeg",
  corner_column: B + "fb000e2515859f80f4841613580bd1079f8cfb2eea45ec0eb166ec1fe60a71ac.jpeg",
  athletes: B + "90cb909329e4bb40d35600eea367fc0e9e116c9821781fa9989eda62d20c0055.jpeg",
  multi_zones: B + "fb54f0a3e882553035899b1db0e3ae62f6272993a70ca3d02232ec45d410ed10.jpeg",
  mma_room: B + "e536471f8bd1ecbc2206a3316ca1aa3e45979fa477441b87b12609b7c7b05d18.jpeg",
  puzzle_progress: B + "092fd758794eba1dd20e87e0d5965aed254c69793fa96d4292c1278f076e38c2.jpeg",
  swatches: B + "b1ec34af3f80541d8a6534715ca0f4cf9fdda3c8f24664ef464cb776e77af356.jpeg",
  mat_care: B + "4edde4672f293c66f06e013df52aad82fab2e123b0446d2658cf06a061cefc2f.jpeg",
  floor_plan: B + "c4ab637dad2e3e46d4ae7d2e3f056f34f5f41d3cf1ca404b0b5866aacf2f83e6.jpeg",
  judo_modern: B + "426ad34597a064ea5c3a0269b8deeb9a045635be864bf5a2d8fae4411a0f89fa.jpeg",
  judo_academy: B + "20908a35cadc2d67107907b0635cd3fc48ac711c56e2cf450f60e85592d09d3c.jpeg",
  custom_logo: B + "d74482cecb5d24e596026752510eef1825385ae63457b5ae0ca6ee5c02ad17af.jpeg",
  branded_wall_pad: B + "41a47dedceda788d6eea72dcc10804c5f6c74dd30d19312f68498145d933bc9a.jpeg",
  branded_rollout: B + "da768e8460747094732b88d475e59ec4ac9709fcba55b5cd583ff6cca223cf1a.jpeg",
  branded_panel: B + "abd8af4f7ed02d8f6598a31518c1398b6b6448be1aa8dedc9323da2f1cb1e3f3.jpeg",
  hero_branded: B + "8cffdef1455e017c870ca6b27fd187dd540b1a151667545fce3044e2ea6803a5.jpeg",
  mma_rollout: B + "d0a0382955a65771a36576bf964a1aa70ffe8a6593025c28f617004760d84d1d.jpeg",
  multi_three: B + "c831674a4f1ee409dcddf5ac8b03b6a30114cb55c8e37bc492764d960fd994b4.jpeg",
};
